<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title> Results </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-card class="mt-4">
        <v-row class="py-3">
          <!-- <v-col cols="12" sm="3" class="d-flex justify-center align-center"
            ><img
              src="https://chatme04.chatme.co.th/CMStorage/sum1626167778019.png"
              class="ma-6"
              width="110"
          /></v-col> -->
          <v-col cols="12" sm="4" class="d-flex justify-center align-center">
            <v-row class="text-center">
              <v-col cols="12" class="display-1 blue--text"
                ><span>{{ general.surveyAction }}</span></v-col
              >
              <v-col cols="12">จำนวนการทำแบบสอบถามทั้งหมด</v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex justify-center align-center">
            <v-row class="text-center">
              <v-col cols="12" class="display-1 green--text">
                <span>{{ general.surveySuccess }}</span></v-col
              >
              <v-col cols="12">จำนวนการทำแบบสอบถามสำเร็จ</v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex justify-center align-center">
            <v-row class="text-center">
              <v-col cols="12" class="display-1 orange--text">
                <span>{{
                  general.surveyAction - general.surveySuccess
                }}</span></v-col
              >
              <v-col cols="12">จำนวนการทำแบบสอบถามไม่สำเร็จ</v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <br />
      <br />
      คำถามทั้งหมด: {{ storeQuestion.length }} ข้อ
      <br />
      <br />
      <v-row>
        <v-col cols="12" md="5"> </v-col>
        <v-col cols="12" md="7" class="d-flex align-center">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="ThaiDate(date)"
                label="เลือกวันที่จะดู"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              scrollable
              range
              no-title
              :max="today"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="DateRange"> OK </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row v-for="(q, i) in storeQuestion" :key="i">
        <v-col cols="12">
          <v-card>
            <SummaryLabel :q="q" :daterange="date" :modal="modal" :index="i" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import SummaryLabel from "../../components/Dashboard/QuestionType/SummaryLabel";
export default {
  components: { SummaryLabel },
  data() {
    return {
      date: [
        new Date(new Date().setDate(new Date().getDate() - 15))
          .toISOString()
          .substring(0, 10),
        new Date().toISOString().substring(0, 10),
      ],
      today: new Date().toISOString().substr(0, 10),
      modal: false,
      general: {
        launchDate: "1990-01-01",
        surveyStatus: false,
        allQuestion: 0,
        surveyAction: 0,
        surveySuccess: 0,
        latestResponse: "2021-05-13",
        surveyToday: 0,
        highActionDate: "1990-01-01",
        highActionAmount: 0,
      },
    };
  },
  computed: {
    RPermission() {
      return this.$store.state.user_permission.report;
    },
    storeQuestion() {
      if (this.$store.state.user_permission.report.view) {
        let allquestion = this.$store.state.allquestion;
        let connect = [];
        allquestion.map((question) => {
          if (
            question.questionType === "connect" ||
            question.questionType === "start"
          ) {
            connect.push(question);
          }
        });
        connect.sort(function (a, b) {
          return a.indexing - b.indexing;
        });
        return connect;
      }
      return [];
    },
  },
  mounted() {
    this.$vuetify.goTo(0, {
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
    });
    this.getGeneral();
  },
  methods: {
    getGeneral() {
      this.$store.dispatch("CheckPermission").then((resp_role) => {
        if (resp_role.data.permission) {
          if (Object.keys(resp_role.data.permission).length !== 0) {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            // console.log(resp_role.data.permission);
            if (resp_role.data.permission.report.view) {
              this.$store
                .dispatch("DashboardGeneral")
                .then((response) => {
                  this.general = response;
                })
                .catch((err) => {
                  if (err.data.message === "Permission Denied") {
                    Swal.fire({
                      icon: "warning",
                      text: "สิทธิ์ของคุณถูกปฏิเสธ",
                      title: "",
                    }).then(() => {
                      this.$store
                        .dispatch("CheckPermission")
                        .then(async (resp_role) => {
                          if (resp_role.data.permission) {
                            this.$store.commit(
                              "UpdateUserPermission",
                              resp_role.data
                            );
                            this.$router.push({
                              name: "question",
                            });
                          }
                        });
                    });
                  } else if (err.data.message === "Survey Not Avaliable.") {
                    this.$store.commit("ToggleLoading");
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: "ไม่สามารถดูข้อมูลได้ (DashboardGeneral)",
                      title: "",
                    });
                  }
                });
            } else {
              Swal.fire({
                icon: "error",
                text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
                title: "",
              }).then(() => {
                this.$router.push({
                  name: "question",
                });
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              this.$router.push({
                name: "question",
              });
            });
          }
        }
      });
    },
    PlusDay(dayadd) {
      var result = new Date(this.dateExpirePackage);
      result.setDate(result.getDate() + dayadd);
      this.dateExpirePackage = result.toISOString().substring(0, 10);
    },
    PlusMonth(monthadd) {
      let d = new Date(this.dateExpirePackage);
      let lastdayofmonth = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      if (d.getDate() === lastdayofmonth.getDate()) {
        let last = new Date(d.getFullYear(), d.getMonth() + 1 + monthadd, 0);
        let day = last.getDate();
        let month =
          last.getMonth() + 1 < 10
            ? `0${last.getMonth() + 1}`
            : last.getMonth() + 1;
        let year = last.getFullYear();
        this.dateExpirePackage = `${year}-${month}-${day}`;
      } else {
        let nextdate = new Date(d.setMonth(d.getMonth() + monthadd));
        d = new Date(this.dateExpirePackage);
        if (d.getMonth() + monthadd === nextdate.getMonth()) {
          this.dateExpirePackage = new Date(
            new Date(this.dateExpirePackage).setMonth(
              new Date(this.dateExpirePackage).getMonth() + monthadd
            )
          )
            .toISOString()
            .substring(0, 10);
        } else {
          let last = new Date(nextdate.setDate(0));
          let day = last.getDate();
          let month =
            last.getMonth() + 1 < 10
              ? `0${last.getMonth() + 1}`
              : last.getMonth() + 1;
          let year = last.getFullYear();
          this.dateExpirePackage = `${year}-${month}-${day}`;
        }
      }
    },
    DateRange() {
      this.$store.dispatch("CheckPermission").then((resp_role) => {
        if (resp_role.data.permission) {
          if (Object.keys(resp_role.data.permission).length !== 0) {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            if (resp_role.data.permission.report.view) {
              this.$store.dispatch("checkPackage").then(() => {
                this.$refs.dialog.save(this.date);
                if (this.date.length > 1) {
                  this.date.sort(function (a, b) {
                    return new Date(a) - new Date(b);
                  });
                } else {
                  this.date.push(this.date[0]);
                }
                this.modal = false;
              });
            } else {
              Swal.fire({
                icon: "error",
                text: "สิทธิ์ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                this.$router.push({
                  name: "question",
                });
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              this.$router.push({
                name: "question",
              });
            });
          }
        }
      });
    },
    dateConvert(d) {
      var day = [
        "วันอาทิตย์",
        "วันจันทร์",
        "วันอังคาร",
        "วันพุธ",
        "วันพฤหัสบดี",
        "วันศุกร์",
        "วันเสาร์",
      ];
      var month = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      var date = new Date(d);
      var text =
        day[date.getDay()] +
        "ที่ " +
        date.getDate() +
        " " +
        month[date.getMonth()] +
        " " +
        (date.getFullYear() + 543);
      return text;
    },
    ThaiDate(array) {
      let arrayModify = JSON.parse(JSON.stringify(array));
      if (arrayModify.length > 1) {
        arrayModify.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });
      }
      let convert = [];
      for (const key in arrayModify) {
        const element = arrayModify[key];
        convert.push(this.dateConvert(element));
      }
      return convert.join(" ~ ");
    },
  },
};
</script>

<style lang="scss" scoped></style>
